import React from 'react';
import { LayoutGrid, List } from 'lucide-react';
import './ViewToggle.css';

export type ViewMode = 'kanban' | 'list';

interface ViewToggleProps {
  currentView: ViewMode;
  onViewChange: (view: ViewMode) => void;
}

const ViewToggle: React.FC<ViewToggleProps> = ({ currentView, onViewChange }) => {
  return (
    <div className="view-toggle">
      <button
        className={`view-toggle-btn ${currentView === 'kanban' ? 'active' : ''}`}
        onClick={() => onViewChange('kanban')}
        title="Kanban Board View"
      >
        <LayoutGrid size={18} />
        <span>Kanban</span>
      </button>
      <button
        className={`view-toggle-btn ${currentView === 'list' ? 'active' : ''}`}
        onClick={() => onViewChange('list')}
        title="List View"
      >
        <List size={18} />
        <span>List</span>
      </button>
    </div>
  );
};

export default ViewToggle; 